/**
 * 台账设备类型接口
 */
import Axios from '@/components/api/axios.js'

export default {
   getUnitBoardRanking(typeCode,startTime,endTime,dayType,searchType,success,failure) {
   		Axios.post('/entity/getUnitBoardRanking.do', {
			typeCode,startTime,endTime,dayType,searchType
		},success,failure)
   },
	/**
	 * 获取台账设备模板树
	 */
	getEntityTypeList(success, failure) {
		Axios.post('/entity/getEntityTypeList.do', {}, success, failure);
	},
	/**
	 * 新增类型
	 */
	createEntityType(typeCode, typeName, typeEnum,mainTypeCode, sort, success, failure) {
		Axios.post('/entity/createEntityType.do', {
			typeCode,
			typeName,
			typeEnum,
			mainTypeCode,
			sort
		}, success, failure);
	},
	/**
	 * 删除类型
	 */
	deleteEntityType(typeCode, success, failure) {
		Axios.post('/entity/deleteEntityType.do', {
			typeCode,
		}, success, failure);
	},
	updateEntityType(typeCode, typeName, isRank,typeEnum, mainTypeCode, sort, success, failure) {
		Axios.post('/entity/updateEntityType.do', {
			typeCode,
			typeName,
			isRank,
			typeEnum,
			mainTypeCode,
			sort
		}, success, failure);
	},
	setEntityTypeEditAble(typeCode, editAble, success, failure) {
		Axios.post('/entity/setEntityTypeEditAble.do', {
			typeCode,
			editAble
		}, success, failure);
	},
	/**
	 * 添加属性
	 */
	createTypeProperty(entityTypeCode, typePropertyCode, propertyName, valueType, readOnly, editable, isOnly, nullable, isVisiAble, align, enumCode, sort, tag, formula, orderFlag, defaultValue, success, failure) {
		Axios.post('/entity/createTypeProperty.do', {
			entityTypeCode,
			typePropertyCode,
			propertyName,
			valueType,
			readOnly,
			editable,
			isOnly,
			nullable,
			isVisiAble,
			align,
			enumCode,
			sort,
			tag,
			formula,
			orderFlag,
			defaultValue
		}, success, failure);
	},
	updateTypeProperty(entityTypeCode, typePropertyCode, propertyName, valueType, readOnly, editable, isOnly, nullable, isVisiAble, align, enumCode, sort, tag, formula, orderFlag, defaultValue, success, failure) {
		Axios.post('/entity/updateTypeProperty.do', {
			entityTypeCode,
			typePropertyCode,
			propertyName,
			valueType,
			readOnly,
			editable,
			isOnly,
			nullable,
			isVisiAble,
			align,
			enumCode,
			sort,
			tag,
			formula,
			orderFlag,
			defaultValue
		}, success, failure);
	},
	deleteTypeProperty(typeCode, typePropertyCode, success, failure) {
		Axios.post('/entity/deleteTypeProperty.do', {
			typeCode,
			typePropertyCode
		}, success, failure);
	},
	getTypePropertyList(typeCode, success, failure) {
		Axios.post('/entity/getTypePropertyList.do', {
			typeCode,
		}, success, failure);
	},
    getArchivesDeviceRanking(typeCode,success,failure) {
		Axios.post('/entity/getArchivesDeviceRanking.do', {
			typeCode,
		}, success, failure)
	}

}